// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/associations/Associat... Remove this comment to see the full error message
import { refreshAssociations } from 'crm_data/associations/AssociationsActions';
import { CALL, EMAIL } from 'customer-data-communicator/schema/interactions/InteractionTypes';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-objects-ui-compo... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { denormalizeTypeId, normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { isLegacyObjectType } from 'customer-data-objects/types/LegacyObjectType';
import { ASSOCIATED_OBJECTS_CARD, COMPANY_PARENT_CHILD_CARD, DEAL_SPLITS_CARD, GDPR_SUBSCRIPTIONS_CARD, PROFILE_QUOTES_CARD, DEAL_COLLABORATORS_CARD, PIPELINE_APPROVALS_CARD
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-sidebar/universa... Remove this comment to see the full error message
} from 'customer-data-sidebar/universal/UniversalSidebarCardTypes';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { fromJS } from 'immutable';
import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import partial from 'transmute/partial';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm-activity-creator-interacti... Remove this comment to see the full error message
import { refreshAssociatedOpenObjects } from 'crm-activity-creator-interactions-legacy/crm_ui/engagementAssociations/actions/AssociatedOpenObjectsActions';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import CrmLocationResolver from 'crm-cards/CrmLocationResolver';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { universalEditableAreas } from 'customer-data-properties/savebar/EditableAreas';
import CrmCardsDragList from 'crm-cards-dnd/CrmCardsDragList';
import CrmCardsDragHandle from 'crm-cards-dnd/CrmCardsDragHandle';
import { RecordsFeatures } from '../../constants/crmFeatures';
import useAuth from '../../crm_ui/profile/hooks/useAuth';
import { getCardRegistry } from '../../cardRegistry/RecordPageCardRegistry';
import { gate } from 'hub-http/gates';
import { getI18nProvider } from 'quartz-core/framework/i18n';
import { usageTracker } from '../../usageTracker';
import CollapsibleListCardFormatter from 'crm-cards-sdk/card-formatters/CollapsibleListCardFormatter';
import { withCardFormatter } from 'crm-cards/utils/withCardFormatter';
import CardListContainerFormatter from 'crm-cards/container-formatters/CardListContainerFormatter';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { withCollapseAPI } from 'crm-cards/withCollapseAPI';
import SingleCardContainerFormatter from 'crm-cards/container-formatters/SingleCardContainerFormatter';
import FullContainerTileCardFormatter from 'crm-cards-sdk/card-formatters/FullContainerTileCardFormatter';
import { jsx as _jsx } from "react/jsx-runtime";
const CUSTOM_LAYOUTS = {
  STACK: withCardFormatter(CardListContainerFormatter, withCollapseAPI(CollapsibleListCardFormatter)),
  SINGLE_CARD: withCardFormatter(SingleCardContainerFormatter, FullContainerTileCardFormatter)
};
const OFFSCREEN_CARDS_POLICY_UNGATED = {
  type: 'AFTER_INITIAL_LOAD',
  delay: 5000
};
export const CardsSidebar = props => {
  const {
    cardLocation,
    objectType,
    subjectId,
    RhumbMarkerSuccess,
    RhumbMarkerError,
    onCommunicatorClick,
    onLocationQueryFinished
  } = props;
  const auth = useAuth();
  const theme = useTheme();
  const [isAddingSubscription, setIsAddingSubscription] = useState(false);
  const [showSubscriptionPanel, setShowSubscriptionPanel] = useState(false);
  // i must commit this atrocity to allow one iframe handler to be available
  // to both an independent action and card component
  const [showIFrameProxy, setShowIFrameProxy] = useState(() => () => {});
  // same here :(
  const [isDealSplitSidebarOpen, setIsDealSplitSidebarOpen] = useState(false);
  const [isDealCollaboratorsSidebarOpen, setIsDealCollaboratorsSidebarOpen] = useState(false);
  useOnCrmMessageTopic(TOPIC_NAMES.UPDATE_ASSOCIATIONS, ({
    objectId,
    objectTypeId,
    toObjectTypeId
  }) => {
    const associationObjectType = denormalizeTypeId(toObjectTypeId);
    const updatedObjectType = denormalizeTypeId(objectTypeId);
    if (isLegacyObjectType(associationObjectType)) {
      // update associated open objects store for communicator
      refreshAssociatedOpenObjects(fromJS([{
        subjectId: objectId,
        objectType: updatedObjectType,
        objectTypeToFetch: associationObjectType
      }]));
      // update associations store for legacy object creator
      refreshAssociations({
        objectId,
        objectType: updatedObjectType,
        associationObjectType
      });
    }
  });
  const getEmailClickHandler = useCallback(() => {
    return onCommunicatorClick && partial(onCommunicatorClick, EMAIL, objectType, subjectId);
  }, [objectType, onCommunicatorClick, subjectId]);
  const getPhoneClickHandler = useCallback(() => {
    return onCommunicatorClick && partial(onCommunicatorClick, CALL, objectType, subjectId);
  }, [objectType, onCommunicatorClick, subjectId]);

  // Stuff for GDPRSubscription Data Density
  const handleOpenAddSubscriptionPanel = useCallback(() => {
    CrmLogger.log('communicationSubscriptionCardInteraction', {
      action: 'open add subscription'
    });
    setShowSubscriptionPanel(true);
    setIsAddingSubscription(true);
  }, []);
  const legacyCardProps = useMemo(() => {
    return {
      [ASSOCIATED_OBJECTS_CARD]: {
        onEmailClick: getEmailClickHandler(),
        onPhoneClick: getPhoneClickHandler()
      },
      [COMPANY_PARENT_CHILD_CARD]: {
        onEmailClick: getEmailClickHandler(),
        onPhoneClick: getPhoneClickHandler()
      },
      [DEAL_SPLITS_CARD]: {
        setIsDealSplitSidebarOpen,
        isDealSplitSidebarOpen,
        hasContentsSidebar: false
      },
      [DEAL_COLLABORATORS_CARD]: {
        setIsDealCollaboratorsSidebarOpen,
        isDealCollaboratorsSidebarOpen,
        hasContentsSidebar: false
      },
      [GDPR_SUBSCRIPTIONS_CARD]: {
        isAddingSubscription,
        setIsAddingSubscription,
        handleOpenAddSubscriptionPanel,
        showPanel: showSubscriptionPanel,
        setShowPanel: setShowSubscriptionPanel,
        auth
      },
      [PROFILE_QUOTES_CARD]: {
        showIFrameProxy,
        setShowIFrameProxy
      },
      [PIPELINE_APPROVALS_CARD]: {
        onTrack: (action, subAction) => {
          CrmLogger.log('recordInteractions', {
            action,
            subAction
          });
        }
      }
    };
  }, [auth, showSubscriptionPanel, showIFrameProxy, getEmailClickHandler, getPhoneClickHandler, isDealSplitSidebarOpen, isDealCollaboratorsSidebarOpen, isAddingSubscription, handleOpenAddSubscriptionPanel]);
  const resolverAdditionalLocationData = useMemo(() => ({
    objectId: subjectId != null ? +subjectId : undefined,
    objectTypeId: normalizeTypeId(objectType)
  }), [objectType, subjectId]);
  const resolverDragDropComponents = useMemo(() => ({
    DragHandle: CrmCardsDragHandle,
    DragList: CrmCardsDragList
  }), []);
  const isUngatedForOffscreenCards = auth.gates.includes(gate('CRM:card-infra-frontend:offscreen-cards:CRM-RECORD'));
  return /*#__PURE__*/_jsx(CrmLocationResolver, {
    customLayouts: isTrellisTheme(theme) ? CUSTOM_LAYOUTS : undefined,
    usageTracker: usageTracker,
    additionalLocationData: resolverAdditionalLocationData,
    dragDropComponents: resolverDragDropComponents,
    editableAreasAtom: universalEditableAreas,
    enableVirtualization: true,
    errorNavMarker: RhumbMarkerError,
    features: RecordsFeatures,
    gates: auth.gates,
    i18nLoader: getI18nProvider(),
    legacySidebarCardProps: legacyCardProps,
    location: cardLocation,
    onQueryFinished: onLocationQueryFinished,
    readyNavMarker: RhumbMarkerSuccess,
    registry: getCardRegistry(),
    scopes: auth.user.scopes,
    offscreenCardsPolicy: isUngatedForOffscreenCards ? OFFSCREEN_CARDS_POLICY_UNGATED : undefined
  });
};
CardsSidebar.propTypes = {
  cardLocation: PropTypes.string,
  objectType: AnyCrmObjectTypePropType.isRequired,
  subjectId: PropTypes.string,
  RhumbMarkerSuccess: PropTypes.node,
  RhumbMarkerError: PropTypes.node,
  onCommunicatorClick: PropTypes.func
};
export default CardsSidebar;